import sectionFormFields from '@/components/sections/form-fields/design/section'
import structureFormFields from '@/components/sections/form-fields/layout/structure'

export const content = {
  html: { label: 'HTML', type: 'html-editor' }
}

export const design = {
  ...sectionFormFields
}

export const layout = {
  ...structureFormFields
}

export const advanced = {}

export default {
  content,
  design,
  layout,
  advanced
}
